import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Icon, Breadcrumb, Table, Tab, Button, Segment, Step, Message, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import useFetch from 'use-http';
import { Formik } from 'formik';
import MyMenu from '../menu';
import { BooleanInput, TextInput, TableLine } from '../inputs';
import { connect } from 'react-redux';
import 'react-intl-tel-input/dist/main.css';
import { post } from '../../../util/api';
import AccountProgress from '../../../components/AccountProgress';
import { withTranslation, useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';

const fetch_config = { responseType: 'json', cachePolicy: 'no-cache' };
const COMMENT_OPTION_KEYS = ['instagram_comments', 'instagram_comment_reply_comment', 'open_instagram_comment_reply', 'instagram_comment_reply'];

const FACE_APP_ID = process.env.REACT_APP_FACE_APP_ID || '296064065127789';
const FACE_APP_REDIRECT_URL = process.env.REACT_APP_FACE_APP_REDIRECT_URL || 'https://app.dialogtab.com/settings/integrations/instagram-messenger/';
//const redirect_url = `https://www.facebook.com/v15.0/dialog/oauth?client_id=${FACE_APP_ID}&display=page&extras={%22setup%22:{%22channel%22:%22IG_API_ONBOARDING%22}}&redirect_uri=${FACE_APP_REDIRECT_URL}&response_type=token&scope=pages_messaging,instagram_basic,instagram_manage_messages,pages_manage_metadata,instagram_manage_comments,pages_read_engagement,pages_read_user_content,pages_show_list`;
const redirect_url = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACE_APP_ID}&display=page&redirect_uri=${FACE_APP_REDIRECT_URL}&response_type=token&scope=pages_messaging,instagram_basic,instagram_manage_messages,pages_manage_metadata,instagram_manage_comments,pages_read_engagement,pages_show_list,business_management`;

function InstagramCommentOptions() {
	const { t } = useTranslation();
	const { loading, response } = useFetch('/api/dahi/message/getLiveChat', fetch_config, []);
	const result = response && response.data && response.data.result;
	const initialValues = React.useMemo(() => {
		if (!result) return { agent: {} };
		const { staticOptions, agentOptions } = result;
		const combined = _.assignIn({}, agentOptions, staticOptions);
		return { agent: _.pick(combined, COMMENT_OPTION_KEYS) };
	}, [result]);
	if (loading)
		return (
			<Tab.Pane>
				<div style={{ textAlign: 'center' }}>
					<Icon name="asterisk" loading></Icon>
					<p>{t('loading')}</p>
				</div>
			</Tab.Pane>
		);
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values, actions) => {
				fetch('/api/dahi/channel/save', {
					method: 'POST',
					body: JSON.stringify({
						channel: 'live',
						data: {
							set: {
								staticOptions: _.pick(values.agent, COMMENT_OPTION_KEYS),
							},
						},
					}),
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => {
						return response.json();
					})
					.then(() => {
						actions.resetForm(values);
						actions.setSubmitting(false);
					})
					.catch((e) => {
						console.error(e);
						actions.setSubmitting(false);
					});
			}}
		>
			{(props) => (
				<Tab.Pane>
					<form onSubmit={props.handleSubmit}>
						<Prompt when={props.dirty} message={() => t('questionWithoutSaving')} />
						<Table definition>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell width={2} />
									<Table.HeaderCell>{t('value')}</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								<TableLine title={t('instagramComment')} description={t('instagramCommentDesc')}>
									<BooleanInput name="agent.instagram_comments" />
								</TableLine>
								<TableLine title={t('instagram_comment_reply_comment')} description={t('instagram_comment_reply_commentDesc')}>
									<BooleanInput name="agent.instagram_comment_reply_comment" />
								</TableLine>
								<TableLine title={t('open_instagram_comment_reply')} description={t('open_instagram_comment_replyDesc')}>
									<BooleanInput name="agent.open_instagram_comment_reply" />
								</TableLine>
								<TableLine title={t('instagram_comment_reply')} description={t('instagram_comment_replyDesc')}>
									<TextInput name="agent.instagram_comment_reply" />
								</TableLine>
							</Table.Body>
						</Table>
						<div style={{ textAlign: 'end' }}>
							<Button loading={props.isSubmitting} primary type="submit">
								{t('saveChanges')}
							</Button>
						</div>
					</form>
				</Tab.Pane>
			)}
		</Formik>
	);
}

class PageSeceltor extends Component {
	state = { loading: true, buttonLoading: -1, list: [], error: false, status: null, accounts: [], connectedPages: null, error_message: null };

	componentDidMount() {
		console.log('props', this.props);
		let accounts = this.props.accounts;
		let connectedPages = this.props.connectedpages;
		let noconnected_pages = [];
		if (accounts) {
			for (let i = 0; i < accounts.length; i++) {
				const element = accounts[i];
				if (
					element.id &&
					!_.find(connectedPages, (e, j) => {
						return e.shop === element.id;
					})
				) {
					noconnected_pages.push(element);
				}
			}
		}
		if (this.props && this.props.error_description) {
			this.setState({ error_description: this.props.error_description });
		}
		if (this.props && this.props.error) {
			this.setState({ error: this.props.error });
		}
		this.setState({ accounts: noconnected_pages, connectedPages, loading: false });
	}

	connect = (props) => async () => {
		this.setState({ buttonLoading: props.id });

		try {
			const response = await post('/messenger/register/insta/connect', {
				page_id: props.id,
				page_access_token: props.token,
			});
			console.log('response', response);
			if (response && response.data && response.data.success === false) {
				// Hata mesajını göster
				this.setState({
					buttonLoading: -1,
					error: response.data.error,
				});
				return; // İşlemi burada sonlandır
			}

			// Başarılı durumda channel/save çağrısı yapma
			// Bu kısım artık çalışmayacak çünkü hata durumunda return yapıyoruz
			const channelResponse = await fetch('/api/dahi/channel/save', {
				method: 'POST',
				body: JSON.stringify({
					channel: 'live',
					data: {
						set: {
							staticOptions: {
								filter_instagram: true,
							},
						},
					},
				}),
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (channelResponse.ok) {
				const data = await channelResponse.json();
				this.setState({ buttonLoading: -1 });
				window.location.reload();
			}
		} catch (error) {
			console.error(error);
			this.setState({
				buttonLoading: false,
				error: true,
			});
		}
	};
	disconnect = (props) => async () => {
		this.setState({ buttonLoading: props.id });
		await post('/messenger/register/insta/disconnect', { page_id: props.id, page_access_token: props.token }).then((response) => {
			this.setState({ buttonLoading: -1 });
			window.location.reload();
		});
	};
	render() {
		/* console.log('sss', this.state.connectedPages, this.state.list); */
		const { t } = this.props;
		let { status, accounts, connectedPages, error_description } = this.state;
		//let { error } = this.state;
		if (this.state.loading)
			return (
				<div style={{ textAlign: 'center' }}>
					<Icon name="asterisk" loading></Icon>
					<p>{t('loading')}</p>
				</div>
			);
		return (
			<div>
				<div style={{ textAlign: 'end', marginBottom: '10px' }}>
					<Button color="blue" target="_blank" as={'a'} href={redirect_url}>
						{'Connect Page With Instagram'}
					</Button>
				</div>
				<div style={{ textAlign: 'end' }}>
					{this.state.error && (
						<Message error style={{ textAlign: 'center', marginBottom: '1em' }}>
							{this.state.error}
						</Message>
					)}
					{error_description && (
						<Message error style={{ textAlign: 'center' }}>
							{error_description}
						</Message>
					)}
					{accounts && accounts.length > 0 && (
						<Table>
							{_.map(
								accounts,
								(it, i) =>
									!_.find(this.state.connectedPages, { shop: it.id }) && (
										<Table.Row key={'insta-' + i}>
											<Table.Cell key={'insta-cell-' + i} width={12}>
												<a href={'https://m.me/' + it.id} target="_blank" rel="noopener noreferrer">
													{it.name}
												</a>
											</Table.Cell>
											<Table.Cell key={'insta-cell2-' + i} style={{ textAlign: 'end' }}>
												<Button
													color={connectedPages ? (!_.find(this.state.connectedPages, { shop: it.id }) ? 'green' : 'red') : 'green'}
													loading={this.state.buttonLoading === it.id}
													onClick={this.connect({ id: it.id, token: it.access_token })}
												>
													{!_.find(this.state.connectedPages, { shop: it.id }) ? t('connect') : t('disconnect')}
												</Button>
											</Table.Cell>
										</Table.Row>
									)
							)}
						</Table>
					)}
				</div>
			</div>
		);
	}
}

class FacebookMessenger extends Component {
	state = {
		loading: false,
		activeStep: 0,
		result_data: {},
		error_description: null,
		check: false,
	};
	componentDidMount() {
		this.getList();
		post('/messenger/register/integrationCount/instagram').then((data) => this.setState({ connectedCount: data.data.result }));
	}

	connect = (props) => async () => {
		this.setState({ buttonLoading: props.id });

		try {
			const response = await post('/messenger/register/insta/connect', {
				page_id: props.id,
				page_access_token: props.token,
			});

			// API'den gelen hata kontrolü
			if (response && response.data && response.data.success === false) {
				console.log('response', response.data.error);
				this.setState({
					buttonLoading: -1,
					error: response.data.error, // API'den gelen hata mesajı
					error_description: response.data.error,
				});
				return;
			}

			// Sadece başarılı durumda channel/save yapılacak
			if (response.success !== 'error') {
				try {
					const channelResponse = await fetch('/api/dahi/channel/save', {
						method: 'POST',
						body: JSON.stringify({
							channel: 'live',
							data: {
								set: {
									staticOptions: {
										filter_instagram: true,
									},
								},
							},
						}),
						headers: {
							'Content-Type': 'application/json',
						},
					});

					if (channelResponse.ok) {
						const data = await channelResponse.json();
						this.setState({ buttonLoading: -1 });
						window.location.reload();
					}
				} catch (error) {
					console.error(error);
					this.setState({
						buttonLoading: -1,
						error: 'An error occurred during channel save.',
					});
				}
			}
		} catch (error) {
			console.error(error);
			this.setState({
				buttonLoading: -1,
				error: 'Connection failed. Please try again later.',
			});
		}
	};

	lookAtQueries = async () => {
		let { connectedpages } = this.state;
		let { location } = this.props;
		let { hash } = location;
		const params = new Proxy(new URLSearchParams(hash), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		if (params['#access_token']) {
			let access_token = params['#access_token'];
			let data_access_expiration_time = params['#data_access_expiration_time'];
			let expires_in = params['#expires_in'];

			this.setState({ loading: true });
			let rest = await fetch(
				`https://graph.facebook.com/v19.0/me/accounts?access_token=${access_token}&fields=id%2Cname%2Caccess_token%2Cinstagram_business_account`,
				{
					method: 'GET',
				}
			).then((data) => data.json());
			if (rest && rest.error) {
				this.setState({ status: 'denied', error_description: rest.error.message });
			}
			let result_data = { access_token, data_access_expiration_time, expires_in };
			if ((connectedpages && connectedpages.length == 0) || !connectedpages || connectedpages == undefined) {
				this.setState({ check: true });
			}
			this.setState({ status: 'success', accounts: rest.data, loading: false, result_data });
		} else if (params['error'] == 'access_denied') {
			this.setState({ status: 'denied', error_description: params['error_description'] });
		} else {
			this.setState({ loading: false });
		}
	};

	getList = () => {
		post('/messenger/register/insta/list', {}).then((data) => {
			let filtered = _.filter(data.data.result, function (it) {
				return it.accessToken;
			});

			if (filtered && filtered.length > 0) {
				this.setState({ connectedpages: filtered, activeStep: 1 });
			} else {
				this.setState({ connectedpages: null, activeStep: 0 });
			}
			this.lookAtQueries();
		});

		// if (apiresponse) this.setState({ connectedPages, loading: false, list: apiresponse.data });
		// else this.setState({ connectedPages, loading: false, error: 'etc...' });
	};
	disconnect = (props) => async () => {
		this.setState({ buttonLoading: props.id });
		await post('/messenger/register/insta/disconnect', { page_id: props.id, page_access_token: props.token }).then((response) => {
			this.setState({ buttonLoading: -1 });
			window.location.reload();
		});
	};
	render() {
		const { t } = this.props;

		let { check } = this.state;
		console.log('pageee', this.props);
		if (this.state.loading)
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="instagram">
						<Page.Loader />
					</MyMenu>
				</Page>
			);

		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/settings`}>
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
							{t('integrations')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section>Instagram Messenger</Breadcrumb.Section>
					</Breadcrumb>
				}
				extra={
					<div className="ml-auto">
						<AccountProgress></AccountProgress>
					</div>
				}
				flex
			>
				<Prompt
					when={check}
					message={(location, action) => {
						return t('noFoundAccountDetail');
					}}
				/>

				<MyMenu activeItem="instagram">
					<Page.Wrap>
						<Tab
							menu={{ secondary: true, pointing: true }}
							panes={[
								{
									menuItem: { key: 'connection', content: 'Instagram Messenger' },
									render: () => this.renderConnectionPane(),
								},
								{
									menuItem: { key: 'comment-options', content: t('instagramCommentOptions') },
									render: () => <InstagramCommentOptions />,
								},
							]}
						/>
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}

	renderConnectionPane() {
		const { t } = this.props;
		let { connectedCount, connectedpages, activeStep, accounts, error_description } = this.state;
		return (
			<Tab.Pane>
				{this.state.error && (
					<Message error style={{ textAlign: 'center', marginBottom: '1em' }}>
						{this.state.error}
					</Message>
				)}
				<div>
					{connectedCount ? (
						<>
							<Message info style={{ textAlign: 'center' }}>
								{t('connectedCount', { count: connectedCount })}
							</Message>

							{connectedpages && connectedpages.length > 0 ? (
								<>
									<Divider horizontal>{t('connectedPage')}</Divider>
									<Table>
										{_.map(connectedpages, (it) => (
											<Table.Row key={it.shop}>
												<Table.Cell key={it.id} width={12}>
													<a href={'https://m.me/' + it.shop} target="_blank" rel="noopener noreferrer">
														{(it.data && it.data.connected_instagram_account_name) ||
															(it.data && it.data.connected_instagram_account_id)}
													</a>
												</Table.Cell>
												<Table.Cell key={it.shop} style={{ textAlign: 'end' }}>
													{/* {console.log('s', _.find(this.state.connectedPages, { accessToken: it.access_token }))} */}

													<Button
														color={'blue'}
														icon={'cog'}
														content={'Extra'}
														onClick={() => this.props.history.push(`/settings/instagramsettings/icebreakers/${it.shop}`)}
													/>

													<Button
														color={'red'}
														loading={this.state.buttonLoading === it.shop}
														onClick={this.disconnect({ id: it.shop, token: it.accessToken })}
													>
														{t('disconnect')}
													</Button>
												</Table.Cell>
											</Table.Row>
										))}
									</Table>
								</>
							) : (
								<Message warning style={{ textAlign: 'center' }}>
									{t('notFoundAccount')}
								</Message>
							)}
						</>
					) : (
						<Message warning style={{ textAlign: 'center' }}>
							{t('notFoundAccount')}
						</Message>
					)}
					<Message info style={{ textAlign: 'center' }}>
						{t('instagramDesc', { title: window.CONFIG.title })}
					</Message>
					<Step.Group widths={4}>
						<Step active={activeStep === 0} completed={activeStep === 1}>
							<Icon name="instagram" />
							<Step.Content>
								<Step.Title>{t('loginInstagram')}</Step.Title>
							</Step.Content>
						</Step>
						<Step active={activeStep === 1}>
							<Icon name="linkify" />
							<Step.Content>
								<Step.Title>{t('connectToInstagramPage')}</Step.Title>
							</Step.Content>
						</Step>
					</Step.Group>
					{!activeStep && (
						<Segment attached className="login">
							<Button color="blue" target="_blank" as={'a'} href={redirect_url}>
								{t('loginWithInstagram')}
							</Button>
						</Segment>
					)}
					{activeStep ? (
						<PageSeceltor
							t={t}
							accounts={accounts}
							result_data={this.state.result_data}
							connectedpages={connectedpages}
							error_description={error_description}
							error={this.state.error}
						/>
					) : (
						<>
							{accounts && accounts.length > 0 ? (
								<Table>
									{_.map(accounts, (it, i) => (
										<Table.Row key={'insta-' + i}>
											<Table.Cell key={'insta-cell-' + i} width={12}>
												<a href={'https://m.me/' + it.id} target="_blank" rel="noopener noreferrer">
													{it.name}
												</a>
											</Table.Cell>
											<Table.Cell key={'insta-cell2-' + i} style={{ textAlign: 'end' }}>
												<Button
													color={'green'}
													loading={this.state.buttonLoading === it.id}
													onClick={this.connect({ id: it.id, token: it.access_token })}
												>
													{!_.find(this.state.connectedPages, { shop: it.id }) ? t('connect') : t('disconnect')}
												</Button>
											</Table.Cell>
										</Table.Row>
									))}
								</Table>
							) : null}
						</>
					)}
				</div>
				{/* <div>
								<img
									src="/images/insta_instruction.png"
									alt="/images/insta_instruction.png"
									width="900"
									style={{ display: 'flex', margin: 'auto' }}
								></img>
							</div> */}
			</Tab.Pane>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, product: state.product, location: state.router.location });

export default connect(stateToProps)(withTranslation()(FacebookMessenger));
